var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowserFirefox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "{className}",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "browser_firefox_svg__a",
    x1: 446.9,
    y1: 76.85,
    x2: 47.94,
    y2: 461.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ffe847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ffc830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff8b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ff672a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_firefox_svg__b",
    cx: 428.46,
    cy: 55.06,
    r: 501.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ffbd4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ffac31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ff9d17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff563b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ff3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f5156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#eb0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#e50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_firefox_svg__c",
    cx: 245.39,
    cy: 259.88,
    r: 501.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960e18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#b11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#db293d",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f5334b",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_firefox_svg__d",
    cx: 305.8,
    cy: -58.64,
    r: 362.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ffdc3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ff9d12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff980e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_firefox_svg__e",
    cx: 189.98,
    cy: 390.75,
    r: 238.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3a8ee6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5c79f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9059ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c139e6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_firefox_svg__f",
    cx: 252.16,
    cy: 201.25,
    r: 126.48,
    gradientTransform: "matrix(.97 -.24 .28 1.14 -48.36 31.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9059ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8c4ff3",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7716a8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6e008b",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_firefox_svg__g",
    cx: 239.06,
    cy: 34.56,
    r: 171.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffdb27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffc82a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffa930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ff7e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ff7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_firefox_svg__h",
    cx: 373.96,
    cy: -74.29,
    r: 732.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ff5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_firefox_svg__i",
    cx: 304.59,
    cy: 7.07,
    r: 536.37,
    gradientTransform: "matrix(.1 .99 -.65 .07 277.32 -296.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ffe847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ffc830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ff8b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff672a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#e31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_firefox_svg__j",
    cx: 235.02,
    cy: 98.12,
    r: 457.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ff5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "browser_firefox_svg__k",
    cx: 355.69,
    cy: 124.88,
    r: 500.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ffe141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ffaf1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff980e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "browser_firefox_svg__l",
    x1: 442.1,
    y1: 74.79,
    x2: 102.64,
    y2: 414.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff44f",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fff44f",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff44f",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff44f",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.71 166.38c-10.44-25.13-31.6-52.26-48.21-60.83 13.52 26.51 21.34 53.1 24.33 72.94 0 0 0 .14.05.4C427.71 111.15 381.63 83.83 344 24.36c-1.91-3-3.81-6-5.67-9.21-1.05-1.81-1.9-3.45-2.64-5A43.73 43.73 0 0 1 332.1.68a.63.63 0 0 0-.54-.65.86.86 0 0 0-.45 0 .47.47 0 0 0-.11.07c-.06 0-.12.07-.18.09l.1-.13c-60.37 35.36-80.85 100.77-82.73 133.5A120.27 120.27 0 0 0 182 159.05a71.11 71.11 0 0 0-6.22-4.7 111.39 111.39 0 0 1-.67-58.74c-24.69 11.25-43.89 29-57.85 44.71h-.11c-9.53-12.07-8.86-51.88-8.32-60.19-.11-.52-7.1 3.63-8 4.26a174.74 174.74 0 0 0-23.49 20.12 210.18 210.18 0 0 0-22.44 26.91 202.86 202.86 0 0 0-32.25 72.82c-.11.52-.21 1.06-.32 1.59-.45 2.11-2.08 12.7-2.37 15v.53A229.1 229.1 0 0 0 16 254.52v1.23c0 132.72 107.6 240.32 240.32 240.32 118.87 0 217.56-86.3 236.89-199.66.4-3.07.73-6.17 1.09-9.27 4.78-41.22-.53-84.54-15.59-120.76zm-277 188.12c1.12.53 2.18 1.12 3.33 1.64l.16.1c-1.15-.56-2.32-1.14-3.48-1.74zm55-144.95zM454.9 179v-.23.26z",
    fill: "url(#browser_firefox_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478.71 166.38c-10.44-25.13-31.6-52.26-48.21-60.83 13.52 26.51 21.34 53.1 24.33 72.94v.49c22.68 61.48 10.32 124-7.48 162.2-27.54 59.1-94.21 119.68-198.58 116.73-112.67-3.2-212-86.91-230.55-196.46-3.38-17.29 0-26.06 1.7-40.09-2.07 10.81-2.86 13.94-3.89 33.16v1.23c0 132.72 107.6 240.32 240.32 240.32 118.87 0 217.56-86.3 236.89-199.66.4-3.07.73-6.17 1.09-9.27 4.75-41.22-.56-84.54-15.62-120.76z",
    fill: "url(#browser_firefox_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M478.71 166.38c-10.44-25.13-31.6-52.26-48.21-60.83 13.52 26.51 21.34 53.1 24.33 72.94v.49c22.68 61.48 10.32 124-7.48 162.2-27.54 59.1-94.21 119.68-198.58 116.73-112.67-3.2-212-86.91-230.55-196.46-3.38-17.29 0-26.06 1.7-40.09-2.07 10.81-2.86 13.94-3.89 33.16v1.23c0 132.72 107.6 240.32 240.32 240.32 118.87 0 217.56-86.3 236.89-199.66.4-3.07.73-6.17 1.09-9.27 4.75-41.22-.56-84.54-15.62-120.76z",
    fill: "url(#browser_firefox_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361.92 194.62c.53.37 1 .74 1.5 1.11a130.49 130.49 0 0 0-22.32-29.12C266.4 91.91 321.52 4.63 330.81.19l.1-.13c-60.37 35.36-80.85 100.77-82.73 133.5 2.8-.19 5.59-.43 8.44-.43 45.05 0 84.29 24.78 105.3 61.49z",
    fill: "url(#browser_firefox_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256.77 209.54c-.39 6-21.51 26.6-28.9 26.6-68.34 0-79.43 41.34-79.43 41.34 3 34.82 27.26 63.49 56.61 78.66 1.34.69 2.69 1.31 4 1.93 2.35 1 4.71 2 7.06 2.89a106.88 106.88 0 0 0 31.27 6c119.78 5.62 143-143.22 56.55-186.44 22.13-3.85 45.11 5.06 57.94 14.07-21-36.71-60.25-61.49-105.3-61.49-2.85 0-5.64.24-8.44.43A120.27 120.27 0 0 0 182 159.05c3.67 3.11 7.81 7.25 16.52 15.83 16.34 16.12 58.16 32.71 58.25 34.66z",
    fill: "url(#browser_firefox_svg__e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.77 209.54c-.39 6-21.51 26.6-28.9 26.6-68.34 0-79.43 41.34-79.43 41.34 3 34.82 27.26 63.49 56.61 78.66 1.34.69 2.69 1.31 4 1.93 2.35 1 4.71 2 7.06 2.89a106.88 106.88 0 0 0 31.27 6c119.78 5.62 143-143.22 56.55-186.44 22.13-3.85 45.11 5.06 57.94 14.07-21-36.71-60.25-61.49-105.3-61.49-2.85 0-5.64.24-8.44.43A120.27 120.27 0 0 0 182 159.05c3.67 3.11 7.81 7.25 16.52 15.83 16.34 16.12 58.16 32.71 58.25 34.66z",
    fill: "url(#browser_firefox_svg__f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.83 151.06c1.95 1.26 3.55 2.32 5 3.29a111.39 111.39 0 0 1-.67-58.74c-24.69 11.25-43.89 29-57.85 44.71 1.13-.03 35.99-.66 53.52 10.74z",
    fill: "url(#browser_firefox_svg__g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.22 261.45C36.77 371 136.1 454.71 248.85 457.91c104.37 2.95 171-57.63 198.58-116.73 17.8-38.21 30.16-100.72 7.48-162.2v-.46c0 .06 0 .14.05.4 8.52 55.67-19.79 109.6-64.05 146.07a7.3 7.3 0 0 0-.13.31c-86.25 70.23-168.78 42.37-185.49 31-1.16-.56-2.33-1.14-3.49-1.74-50.29-24-71.06-69.85-66.61-109.14-42.45 0-56.93-35.82-56.93-35.82s38.12-27.18 88.36-3.54c46.53 21.9 90.23 3.55 90.23 3.54-.09-1.95-41.91-18.59-58.22-34.66-8.71-8.58-12.85-12.72-16.52-15.83a71.11 71.11 0 0 0-6.22-4.7c-1.43-1-3-2-5-3.29-17.53-11.4-52.39-10.77-53.54-10.74h-.11c-9.53-12.07-8.86-51.88-8.32-60.19-.11-.52-7.1 3.63-8 4.26a174.74 174.74 0 0 0-23.49 20.12 210.18 210.18 0 0 0-22.44 26.91 202.86 202.86 0 0 0-32.25 72.82c-.19.46-8.74 37.79-4.52 57.15z",
    fill: "url(#browser_firefox_svg__h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M341.1 166.61a130.49 130.49 0 0 1 22.32 29.12 46.36 46.36 0 0 1 3.6 3C421.5 248.89 393 319.9 390.83 325c44.26-36.47 72.57-90.4 64.05-146.07-27.17-67.78-73.25-95.1-110.88-154.57-1.91-3-3.81-6-5.67-9.21-1.05-1.81-1.9-3.45-2.64-5A43.73 43.73 0 0 1 332.1.68a.63.63 0 0 0-.54-.65.86.86 0 0 0-.45 0 .47.47 0 0 0-.11.07c-.06 0-.12.07-.18.09-9.3 4.44-64.42 91.72 10.28 166.42z",
    fill: "url(#browser_firefox_svg__i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M367 198.68a46.36 46.36 0 0 0-3.6-3c-.49-.37-1-.74-1.5-1.11-12.83-9-35.81-17.92-57.94-14.07 86.44 43.22 63.23 192.06-56.55 186.44a106.88 106.88 0 0 1-31.27-6c-2.35-.88-4.71-1.85-7.06-2.89-1.36-.62-2.71-1.24-4-1.93l.16.1c16.71 11.4 99.24 39.26 185.49-31 0 0 .05-.13.13-.31C393 319.9 421.5 248.89 367 198.68z",
    fill: "url(#browser_firefox_svg__j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.44 277.48s11.09-41.34 79.43-41.34c7.39 0 28.51-20.62 28.9-26.6s-43.7 18.36-90.23-3.54c-50.24-23.64-88.36 3.54-88.36 3.54s14.48 35.82 56.93 35.82c-4.45 39.29 16.32 85.1 66.61 109.14 1.12.53 2.18 1.12 3.33 1.64-29.35-15.14-53.58-43.84-56.61-78.66z",
    fill: "url(#browser_firefox_svg__k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M478.71 166.38c-10.44-25.13-31.6-52.26-48.21-60.83 13.52 26.51 21.34 53.1 24.33 72.94 0 0 0 .14.05.4C427.71 111.15 381.63 83.83 344 24.36c-1.91-3-3.81-6-5.67-9.21-1.05-1.81-1.9-3.45-2.64-5A43.73 43.73 0 0 1 332.1.68a.63.63 0 0 0-.54-.65.86.86 0 0 0-.45 0 .47.47 0 0 0-.11.07c-.06 0-.12.07-.18.09l.1-.13c-60.37 35.36-80.85 100.77-82.73 133.5 2.8-.19 5.59-.43 8.44-.43 45.05 0 84.29 24.78 105.3 61.49-12.83-9-35.81-17.92-57.94-14.07 86.44 43.22 63.23 192.06-56.55 186.44a106.88 106.88 0 0 1-31.27-6c-2.35-.88-4.71-1.85-7.06-2.89-1.36-.62-2.71-1.24-4-1.93l.16.1c-1.16-.56-2.33-1.14-3.49-1.74 1.12.53 2.18 1.12 3.33 1.64-29.41-15.17-53.64-43.87-56.67-78.69 0 0 11.09-41.34 79.43-41.34 7.39 0 28.51-20.62 28.9-26.6-.09-1.95-41.91-18.59-58.22-34.66-8.71-8.58-12.85-12.72-16.52-15.83a71.11 71.11 0 0 0-6.22-4.7 111.39 111.39 0 0 1-.67-58.74c-24.69 11.25-43.89 29-57.85 44.71h-.11c-9.53-12.07-8.86-51.88-8.32-60.19-.11-.52-7.1 3.63-8 4.26a174.74 174.74 0 0 0-23.49 20.12 210.18 210.18 0 0 0-22.44 26.91 202.86 202.86 0 0 0-32.25 72.82c-.11.52-.21 1.06-.32 1.59-.45 2.11-2.49 12.85-2.77 15.15 0 .18 0-.17 0 0A278.84 278.84 0 0 0 16 254.52v1.23c0 132.72 107.6 240.32 240.32 240.32 118.87 0 217.56-86.3 236.89-199.66.4-3.07.73-6.17 1.09-9.27 4.78-41.22-.53-84.54-15.59-120.76zm-23.84 12.34v.26z",
    fill: "url(#browser_firefox_svg__l)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserFirefox);
export default __webpack_public_path__ + "static/media/browser_firefox.510b9d1a18ab22222d6136c52ec4b03b.svg";
export { ForwardRef as ReactComponent };